import type { FulfillmentType } from '../types/@types/order';
import React from 'react';

export interface FulfillmentSelectorProps {
  value: FulfillmentType;
  disabled?: boolean;
  onChange: (next: FulfillmentType) => void;
  compact?: boolean;
}

export default function FulfillmentSelector({
  value,
  disabled,
  onChange,
  compact,
}: FulfillmentSelectorProps) {
  return (
    <div className={`flex items-center rounded-full bg-slate-100 dark:bg-neutral-800 p-0.5 border border-divider/60 ${compact ? 'gap-0' : 'gap-0.5'}`}>
      <label className={`cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
        <input
          type="radio"
          className="sr-only"
          value="DINE_IN"
          checked={value === 'DINE_IN'}
          disabled={disabled}
          onChange={() => onChange('DINE_IN')}
        />
        <span
          className={`inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 ${compact ? 'px-3 py-1 text-[11px]' : 'px-4 py-1.5 text-xs'} ${
            value === 'DINE_IN'
              ? 'bg-orange-500 text-white shadow-sm'
              : 'text-slate-600 dark:text-neutral-400 hover:text-slate-900 dark:hover:text-neutral-200'
          }`}
        >
          En mesa
        </span>
      </label>
      <label className={`cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
        <input
          type="radio"
          className="sr-only"
          value="TAKEOUT"
          checked={value === 'TAKEOUT'}
          disabled={disabled}
          onChange={() => onChange('TAKEOUT')}
        />
        <span
          className={`inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 ${compact ? 'px-3 py-1 text-[11px]' : 'px-4 py-1.5 text-xs'} ${
            value === 'TAKEOUT'
              ? 'bg-orange-500 text-white shadow-sm'
              : 'text-slate-600 dark:text-neutral-400 hover:text-slate-900 dark:hover:text-neutral-200'
          }`}
        >
          Para llevar
        </span>
      </label>
    </div>
  );
}
